import { computed, ref } from 'vue';
import deepmerge from 'deepmerge';

export function settings(buttons, hierarchy, fallback = 'Salvar') {
  // @IMPORTANT
  // "hieranchy" may mean simply hierarchy OR hierarchy + variant

  const fallbacking = typeof fallback === 'string' ? {
    text: fallback,
  } : fallback;

  if (typeof buttons?.[hierarchy] === 'string') {
    return {
      text: buttons[hierarchy] || fallbacking.text,
    };
  }

  return {
    ...fallbacking,
    ...buttons?.[hierarchy],
  };
}

export default function buttoner(props) {
  const kinds = ref({
    secondary: {
      disabled: false,
      loading: false,
    },
    primary: {
      disabled: false,
      loading: false,
    },
  });

  const buttons = computed(() => {
    const variants = deepmerge(window.CREDERE.variants, props.variants, {});

    return Object.keys(kinds.value)
      .map((i) => {
        const prop = `${i}Button`;

        return {
          text: typeof props[prop] === 'string' ? props[prop] : props[prop]?.text,
          color: i,
          icon: props[prop]?.icon || null,
          variant: variants.button_primary,
          variantSecondary: i === 'secondary' ? variants.button_secondary : null,
          hierarchy: i,
          disabled: kinds.value[i].disabled,
          loading: kinds.value[i].loading,
        };
      })
      .filter((x) => x.text);
  });

  function toggle(boolean) {
    Object
      .keys(kinds.value)
      .forEach((i) => Object.keys(kinds.value[i])
        .forEach((j) => {
          kinds.value[i][j] = boolean;
        }));
  }

  return {
    buttons,
    toggle,
  };
}
